import { graphql } from "react-relay"

import { ViewCreateMutation } from "./__generated__/ViewCreateMutation.graphql"
import { ViewDeleteMutation } from "./__generated__/ViewDeleteMutation.graphql"
import { ViewUpdateMutation } from "./__generated__/ViewUpdateMutation.graphql"

import { environment } from "~/store/hasura"

import { commitMutationPromise } from "./helpers"

const viewCreateMutation = graphql`
  mutation ViewCreateMutation($view: CreateViewInput!) {
    createView(input: $view) {
      createdView {
        id
        databaseId
        name
        type
        description
        projectFilters
        peopleFilters
        userIds
      }
    }
  }
`

type CreateOptions = {
  view: ViewCreateMutation["variables"]["view"]
}

export const viewCreateRelay = async (options: CreateOptions) => {
  const { view } = options
  const data = await commitMutationPromise<ViewCreateMutation>(environment, {
    mutation: viewCreateMutation,
    variables: { view },
    updater: (store) => {
      const availableViews = store.getRoot()?.getLinkedRecords("availableViews")
      if (availableViews) {
        const createdView = store
          .getRootField("createView")
          ?.getLinkedRecord("createdView")
        store
          .getRoot()
          ?.setLinkedRecords([...availableViews, createdView], "availableViews")
      }
    },
  })
  return data.createView.createdView
}

const viewUpdateMutation = graphql`
  mutation ViewUpdateMutation($input: EditViewInput!) {
    editView(input: $input) {
      updatedView {
        databaseId
        type
        name
        description
        projectFilters
        peopleFilters
        userIds
      }
    }
  }
`

export const viewUpdateRelay = async (
  input: ViewUpdateMutation["variables"]["input"],
) => {
  const data = await commitMutationPromise<ViewUpdateMutation>(environment, {
    mutation: viewUpdateMutation,
    variables: { input },
  })
  return data.editView.updatedView.name
}

const viewDeleteMutation = graphql`
  mutation ViewDeleteMutation($id: Int!) {
    deleteView(input: { id: $id }) {
      globalId @deleteRecord
    }
  }
`

export const viewDeleteRelay = async (
  variables: ViewDeleteMutation["variables"],
) => {
  const data = await commitMutationPromise<ViewDeleteMutation>(environment, {
    mutation: viewDeleteMutation,
    variables,
    updater: (store) => {
      const availableViews = store.getRoot()?.getLinkedRecords("availableViews")
      if (availableViews) {
        // remove the deleted view from the allocated views
        const newViews = availableViews.filter(Boolean)
        store.getRoot()?.setLinkedRecords(newViews, "availableViews")
      }
    },
  })
  return data
}
